import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './kioskTheme.css';
import './PaymentResult.css';

function PaymentFailure() {
    const [params] = useSearchParams();
    const txnid = params.get('txnid');
    const loanId = params.get('loanId');
    const reason = params.get('reason');

    return (
        <div className="kiosk-theme pay-page pay-page--failure">
            <div className="pay-card">
                <div className="pay-icon" aria-hidden="true">✕</div>
                <h1 className="pay-title">Payment failed</h1>
                <p className="pay-subtitle">The repayment could not be completed.</p>
                <dl className="pay-details">
                    <div className="pay-detail">
                        <dt>Loan ID</dt>
                        <dd>{loanId || '--'}</dd>
                    </div>
                    <div className="pay-detail">
                        <dt>Transaction ID</dt>
                        <dd>{txnid || '--'}</dd>
                    </div>
                    <div className="pay-detail">
                        <dt>Reason</dt>
                        <dd>{reason || 'Payment was not completed'}</dd>
                    </div>
                </dl>
                <Link to="/dashboard" className="pay-btn">
                    Back to Dashboard
                </Link>
            </div>
        </div>
    );
}

export default PaymentFailure;
